// TODO: move to ENV var
export const SHOPPING_CART_REDIRECT_URL = 'https://www.technischeunie.nl/import/configurationtools/proplanet';
export const SHOW_PRICES = 'false' === 'true';




// WEBPACK FOOTER //
// ./js/config/shopping-cart.js